/**
 * sco design system — radius tokens.
 * Source of truth. Edit directly.
 */

import { defineTokens } from '@chakra-ui/react'

export const radii = defineTokens.radii({
  none: {
    value: '0',
  },
  '2xs': {
    value: '0.063em',
  },
  xs: {
    value: '0.125em',
  },
  sm: {
    value: '0.25em',
  },
  md: {
    value: '0.375em',
  },
  lg: {
    value: '0.5em',
  },
  xl: {
    value: '0.75em',
  },
  '2xl': {
    value: '1em',
  },
  '3xl': {
    value: '1.5em',
  },
  '4xl': {
    value: '2em',
  },
  full: {
    value: '9999px',
  },
})
